<template>
  <div class="container">
    <div>
      <nav-bar title="车辆配置"></nav-bar>
    </div>
    <div class="list">
      <van-collapse v-model="activeName" accordion>
        <van-collapse-item :title="item.title" :name="index" v-for="(item, index) in params" :key="index">
          <van-cell-group>
            <van-cell :title="itemA.k" :value="itemA.v" v-for="(itemA, indexA) in item.tiems" :key="indexA" />
          </van-cell-group>
        </van-collapse-item>
      </van-collapse>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      kindId: '',
      tradeId: '',
      activeName: 0,
      params: [],
      paramsList: []
    }
  },
  created() {
    if (this.$route.query.kindId) {
      this.kindId = this.$route.query.kindId
    }
    if (this.$route.query.tradeId) {
      this.tradeId = this.$route.query.tradeId
    }
    this.loadData()
    window.scrollTo(0, 0)
  },
  methods: {
    async loadData() {
      const { data } = await this.$http.get(this.$store.state.web4open_api + '/web/vehicle/kindConfig', {
        params: {
          kindId: this.kindId
        }
      })
      if (data.success) {
        var list = data.data.list
        var chlidren = list.splice(list.length - 1, 1)
        console.log(chlidren)
        this.params = list.concat(chlidren[0].chlidren)

        // var params = JSON.parse(data.data.params)
        // this.params = Object.keys(params)
        // this.paramsList = Object.values(params)
        // for (var key in params) {
        //   // 遍历第一层key
        //   var obj = {}
        //   obj.key = key
        //   var subParams = params[key]
        //   var subObjs = []
        //   for (var subKey in subParams) {
        //     // 遍历第二层key
        //     var subObj = {}
        //     subObj.key = subKey
        //     subObj.value = subParams[subKey]
        //     subObjs.push(subObj)
        //   }
        //   obj.subObjs = subObjs
        //   this.params.push(obj)
        // }
      }
    },
    onClickLeft() {
      this.$router.go(-1)
    }
  }
}
</script>

<style lang="less" scoped>
.container {
  background-color: #eee;
}
.backBar {
  position: fixed;
  top: 0px;
  z-index: 2;
  height: 46px;
  width: 100%;
}
.van-collapse-item {
  background-color: #dde;
}
.van-cell {
  padding: 4px !important;
  background-color: #eee;
}
</style>
